'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-IJKZ5OMO.mjs";

// src/ui/components/faq/Groups.tsx
import { useState } from "react";
import { twMerge } from "tailwind-merge";
import { useGetFaqByGroup, useGetFaqsGroups } from "@wbk/api/hooks";
import { useRouter, useTranslation } from "@wbk/config";
import { Button as Button2, Carousel, Typography as Typography2 } from "@wbk/ui";

// src/ui/components/faq/Item.tsx
import { Button, Collapsible, Typography } from "@wbk/ui";
import { jsx, jsxs } from "react/jsx-runtime";
var FAQItem = ({ question, answer, index }) => {
  return /* @__PURE__ */ jsx("div", { className: "bg-action/10 hover:border-action/20 overflow-hidden rounded-xl border border-transparent transition-all", children: /* @__PURE__ */ jsx(
    Collapsible,
    {
      trigger: /* @__PURE__ */ jsxs(
        Button,
        {
          className: "flex w-full items-center justify-between gap-0 px-2 py-4 md:px-4",
          theme: "transparent",
          children: [
            /* @__PURE__ */ jsx(Typography, { variant: "heading-S", className: "w-10 shrink-0 md:w-12", children: /* @__PURE__ */ jsx("span", { children: String(index + 1).padStart(2, "0") }) }),
            /* @__PURE__ */ jsx(Typography, { variant: "heading-XS", className: "w-full text-start", children: question }),
            /* @__PURE__ */ jsx(Typography, { variant: "heading-M", as: "span", className: "w-10 shrink-0 md:w-12", children: "+" })
          ]
        }
      ),
      children: /* @__PURE__ */ jsx(
        Typography,
        {
          variant: "body-S",
          className: "px-12 pb-4 pt-0 md:px-16",
          dangerouslySetInnerHTML: { __html: answer },
          color: "text-secondary"
        }
      )
    }
  ) });
};
var Item_default = FAQItem;

// src/ui/components/faq/Groups.tsx
import { jsx as jsx2, jsxs as jsxs2 } from "react/jsx-runtime";
var FAQGroups = ({ organizationSlug, className }) => {
  var _a;
  const { locale } = useRouter();
  const { t } = useTranslation(["ticketing_common", "ticketing_event"]);
  const { data: faqGroups, isLoading: isLoadingFaqGroups } = useGetFaqsGroups(__spreadProps(__spreadValues({}, organizationSlug && { organization_slug: organizationSlug }), {
    locale
  }));
  const [selectedGroup, setSelectedGroup] = useState();
  const activeSelectedGroup = selectedGroup || ((_a = faqGroups == null ? void 0 : faqGroups[0]) == null ? void 0 : _a._id);
  const {
    data: faqsData,
    fetchNextPage,
    hasNextPage,
    isLoading: isLoadingFaqs
  } = useGetFaqByGroup(
    {
      faq_group: activeSelectedGroup || "",
      organization_slug: organizationSlug,
      locale
    },
    {
      enabled: !!(faqGroups == null ? void 0 : faqGroups.length) && !!activeSelectedGroup
    }
  );
  if (isLoadingFaqGroups)
    return /* @__PURE__ */ jsxs2("div", { className: "container space-y-4 py-12", children: [
      /* @__PURE__ */ jsx2("div", { className: "bg-action/10 border-action/10 rounded-M h-14 w-64 animate-pulse border" }),
      /* @__PURE__ */ jsx2("div", { className: "flex gap-2", children: Array.from({ length: 3 }).map((_, index) => /* @__PURE__ */ jsx2(
        "div",
        {
          className: "bg-action/10 border-action/10 rounded-M h-14 w-24 animate-pulse border"
        },
        index
      )) }),
      Array.from({ length: 3 }).map((_, index) => /* @__PURE__ */ jsx2(
        "div",
        {
          className: "bg-action/10 border-action/10 rounded-M h-14 w-full animate-pulse border"
        },
        index
      ))
    ] });
  if (!(faqGroups == null ? void 0 : faqGroups.length)) return null;
  return /* @__PURE__ */ jsxs2("section", { className: twMerge("container py-12", className), children: [
    /* @__PURE__ */ jsx2(Typography2, { variant: "heading-L", className: "mb-8", as: "h2", children: t("ticketing_common:faqs") }),
    /* @__PURE__ */ jsx2(Carousel, { className: "mb-8", containerClassName: "gap-2", options: { dragFree: true }, children: faqGroups == null ? void 0 : faqGroups.map((group) => {
      const isActive = activeSelectedGroup === group._id;
      return /* @__PURE__ */ jsx2(
        Button2,
        {
          theme: isActive ? "primary" : "action",
          shape: isActive ? "solid" : "outlined",
          className: "shrink-0",
          onClick: () => setSelectedGroup(group._id),
          children: group.title
        },
        group._id
      );
    }) }),
    isLoadingFaqs ? /* @__PURE__ */ jsx2("div", { className: "mb-8 space-y-4", children: Array.from({ length: 3 }).map((_, index) => /* @__PURE__ */ jsx2(
      "div",
      {
        className: "bg-action/10 border-action/10 rounded-M h-14 w-full animate-pulse border"
      },
      index
    )) }) : (faqsData == null ? void 0 : faqsData.faqs.length) ? /* @__PURE__ */ jsx2("div", { className: "mb-8 space-y-4", children: faqsData.faqs.map((faq, index) => /* @__PURE__ */ jsx2(Item_default, __spreadValues({ index }, faq), faq._id)) }) : /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", className: "text-center", children: t("ticketing_common:faqs_no_data") }),
    hasNextPage && /* @__PURE__ */ jsx2("div", { className: "flex w-full items-center justify-center", children: /* @__PURE__ */ jsx2(Button2, { theme: "action", shape: "outlined", onClick: () => fetchNextPage(), children: /* @__PURE__ */ jsx2(Typography2, { variant: "body-S", className: "text-center", children: t("ticketing_event:load_more") }) }) })
  ] });
};
var Groups_default = FAQGroups;

export {
  Groups_default
};
//# sourceMappingURL=chunk-QDBDJFIV.mjs.map